module.exports=Flickity;